import { useQuery } from '@tanstack/react-query';
import { useActiveOrg } from '../../providers/useActiveOrg';
import { useTypedOpenApi } from '../../providers/useTypedOpenApi';
import { fetchOrganizationSeats } from './organizationSeats';

export const organizationSeatsKey = (clerkOrgId: string | null) => ['organization-seats', clerkOrgId] as const;

/**
 * The active organization's places, for every member. Keyed by the Clerk org id, so a switch never
 * shows the last organization's. Short-lived: an invite or a removal changes it.
 */
export const useOrganizationSeatsQuery = () => {
  const { apiClient } = useTypedOpenApi();
  const { clerkOrgId } = useActiveOrg();

  return useQuery({
    queryKey: organizationSeatsKey(clerkOrgId),
    queryFn: () => fetchOrganizationSeats(apiClient),
    enabled: clerkOrgId !== null,
    staleTime: 30 * 1000,
    retry: false,
  });
};
